import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=305bf9b8&scoped=true&"
import script from "./Music.vue?vue&type=script&lang=js&"
export * from "./Music.vue?vue&type=script&lang=js&"
import style0 from "./Music.vue?vue&type=style&index=0&id=305bf9b8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305bf9b8",
  null
  
)

export default component.exports